<mat-form-field2
  matAutocompleteOrigin
  #origin="matAutocompleteOrigin"
  [class.invalid]="ngControl?.control?.touched && ngControl?.control?.invalid"
  [showLabel]="showLabel"
>
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #chipList class="py-1 w-100" [formControl]="ctrl" [required]="required">
    <mat-chip-row *ngFor="let value of ctrl.value" (removed)="removeByValue(value)">
      {{ getItemLabelByValue | call : value }}
      <button matChipRemove class="mat-chip-btn">
        <i class="far fa-times"></i>
      </button>
    </mat-chip-row>
    <input
      [placeholder]="ctrl.value?.length ? '' : placeholder"
      [formControl]="tagCtrl"
      [matAutocomplete]="auto"
      [matAutocompleteConnectedTo]="origin"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event.value)"
      class="tag-input"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event)">
    <mat-option *ngFor="let item of filteredTags$ | async" [value]="item">
      {{ getItemLabel | call : item }}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> Tags is required </mat-error>
</mat-form-field2>
